module.exports = __webpack_public_path__ + "static/media/img_fenlei16.340f0a2b.png";